const SERVER_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';            //Live URL

module.exports = {
    URL: {
        SERVER_URL: SERVER_URL,
    }
};